import React from 'react';
import Bluedots from '../../assets/images/blue_dotes.png'
import feature1a from '../../assets/images/feature1a.png'
import feature1b from '../../assets/images/feature1b.png'
import icon1 from '../../assets/images/feature-icon1.png'
import feature2a from '../../assets/images/feature2a.png'
import feature2b from '../../assets/images/feature2b.png'
import icon2 from '../../assets/images/feature-icon2.png'
import feature3a from '../../assets/images/feature3a.png'
import feature3b from '../../assets/images/feature3b.png'
import icon3 from '../../assets/images/feature-icon3.png'
import Emoji from '../../utils/emoji'


function OurMessage() {
    return (
        <section className="row_am task_app_section">
            <div className="task_block" style={{ top: 230, position: 'sticky' }}>
                <div className="dotes_blue" style={{opacity: 60+'%'}}>
                    <img src={Bluedots} alt="image" />
                </div>
                <div className="row">
                   {/*  <div className="col-md-6">
                        
                        <div className="task_img" data-aos="fade-in" data-aos-duration={1500}> 
                            <div className="frame_img">
                                <img src={feature1a} alt="image" />
                            </div>
                            <div className="screen_img">
                                <img className="moving_animation" src={feature1b} alt="image"
                                />
                            </div>
                        </div>
                        
                    </div>*/}
                    <div className="col-md-12">
                        <div className="task_text">
                            <div className="section_title white_text" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                                <span className="title_badge">Mesajul nostru</span>
                                <h2><span style={{fontSize: 2.5 + 'rem'}}>LUMO</span> un serviciu gândit cu grijă, construit cu pasiune</h2>
                                <div className='section_text'>
                                    <div className="section_feature" style={{fontStyle: 'italic', fontWeight: '300', textAlign:'justify'}}><p>„Construim LUMO cu atenție la detalii, cu respect pentru timp și cu dorința de a oferi un produs românesc de care să fim mândri. 
                                        Ne-am propus, încă de la început, să oferim beneficii reale pentru utilizatorii care caută servicii de încredere, dar și pentru furnizorii care merită mai multă vizibilitate și simplitate în gestionarea activității lor. <br/><br/> Ne bucurăm că ești aici.”</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="task_block" style={{ top: 230, position: 'sticky' }}>
                <div className="dotes_blue">
                    <img src={Bluedots} alt="image" />
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="task_img" data-aos="fade-in" data-aos-duration={1500}>
                            <div className="frame_img">
                                <img src={feature2a} alt="image" />
                            </div>
                            <div className="screen_img">
                                <img className="moving_animation" src={feature2b} alt="image" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="task_text">
                            <div className="section_title white_text" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                                <span className="title_badge">Unique Features</span>
                                <span className="icon">
                                    <img src={icon2} alt="image" />
                                </span>
                                <h2>Client comunication for best results</h2>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and setting indus
                                    orem Ipsum has been the industrys standard dummxt ever since the
                                    when an own printer took a galley of type and scrambled it to
                                    make. a type specimen book.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="task_block" style={{ top: 230, position: 'sticky' }}>
                <div className="dotes_blue">
                    <img src={Bluedots} alt="image" />
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="task_img" data-aos="fade-in" data-aos-duration={1500}>
                            <div className="frame_img">
                                <img src={feature3a} alt="image" />
                            </div>
                            <div className="screen_img">
                                <img className="moving_animation" src={feature3b} alt="image" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="task_text">
                            <div className="section_title white_text" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                                <span className="title_badge">Unique Features</span>
                                <span className="icon">
                                    <img src={icon3} alt="image" />
                                </span>
                                <h2>Live chat with Video Call</h2>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and setting indus
                                    orem Ipsum has been the industrys standard dummxt ever since the
                                    when an own printer took a galley of type and scrambled it to
                                    make. a type specimen book.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            */}
        </section>
    );
}

export default OurMessage;
